import dynamic from 'next/dynamic'

import {
  HeroText,
  Container,
  SectionContainer,
} from '../components/index'

const MainContainer = dynamic(() => import('../components').then(mod => mod.MainContainer))
const ThreeColContact = dynamic(() => import('../components').then(mod => mod.ThreeColContact))
const ContactFormSection = dynamic(() => import('../components').then(mod => mod.ContactFormSection))

import { isObjectEmpty } from '../utils'
import { fetchPageByGql } from '../services'
import { PAGE_CONTACT } from '../services/queries/pages'
import getGlobalData from '../services/cacheGlobalData'
import { STATIC_PAGE_WP_IDS } from '../utils/siteConfig'

/**
 * Fixed Page - Contact
 */
export default function Contact({ pageData, bioData }) {
  const header = pageData?.dovetailPageContact?.header
  const ourOffice = pageData?.dovetailPageContact?.ourOffice

  header.items = header.items.map((item) => {
    item.contact.image = item.contact.contactImage
    return item
  })

  return (
    <MainContainer>
      <SectionContainer className='hero-pt'>
        <Container>
          <div className='flex justify-center mb-20 md:mb-100'>
            <HeroText
              text={header?.title}
              className='tracking-4 text-6xl uppercase md:text-9xl'
            />
          </div>
        </Container>

          <ContactFormSection
            image={ourOffice?.image}
            heading={ourOffice?.title}
            subHeading={ourOffice?.headline}
            cta={ ourOffice?.link }
          />

          <ThreeColContact
            contactA={header?.items[0]}
            contactB={header?.items[1]}
            contactInfoHeading={header?.contactInfoHeadline}
            contactInfo={ourOffice?.description}
            cta={ourOffice?.link}
          />
      </SectionContainer>
    </MainContainer>
  )
}

export async function getStaticProps({ preview = false }) {
  const query = PAGE_CONTACT
  const params = {
    pageId: STATIC_PAGE_WP_IDS?.contact
  }

  const responseData = await fetchPageByGql(query, params, preview)
  const pageData = responseData?.pageData || {}
  
  const globalData = await getGlobalData()

  return isObjectEmpty(pageData)
    ? { notFound: true } // returns custom 404 page
    : { props: { preview, pageData, globalData } }
}
